import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { DemurrageDetentionStatusComponent } from './demurrage-detention-status.component';

@NgModule({
  declarations: [DemurrageDetentionStatusComponent],
  imports: [CommonModule, IntrackFeatureModule],
  exports: [DemurrageDetentionStatusComponent],
})
export class DemurrageDetentionStatusModule {}
